module.exports = __webpack_public_path__ + "img/vf1.806f4775.png";